/**
 * Right now, the platform deployment fields comes from the backend.
 * We need to find a way a way to move those to frontend as we need it for validations.
 * I tried to take it up, but wasn't possible in the given time frame.
 * Only with a rewrite of the business manager, I found doing this possible.
 * TODO: Figure out a way to move fixtures to frontend, if not, rewrite to be taken up
 *
 * For now, storing this list as a duplicate. Here, the keys are respective platform ID.
 */
export function validateUrl(value) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    value
  );
}

export const PLATFORMS_REQUIRED_FIELDS = {
  1: {
    name: 'Facebook',
    requiredFields: ['access_token', 'app_secret_key', 'webhook_url', 'emails'],
  },
  7: { name: 'Bot API', requiredFields: ['token', 'webhook_url', 'emails'] },
  9: { name: 'Web SDK', requiredFields: ['token', 'webhook_url', 'emails'] },
  10: {
    name: 'Whatsapp',
    requiredFields: [
      'token',
      'whatsapp_base_url',
      'whatsapp_password',
      'whatsapp_username',
      'waba_id',
      'whatsapp_phone_number',
      'webhook_url',
      'emails',
      'whatsapp_pay_url',
      'whatsapp_payment_config',
    ],
  },
  11: { name: 'IOS SDK', requiredFields: ['token', 'webhook_url', 'emails'] },
  12: {
    name: 'Android SDK',
    requiredFields: ['token', 'webhook_url', 'emails'],
  },
  19: {
    name: 'Gupshup Chat Connector',
    requiredFields: [
      'token',
      'gupshup_base_url',
      'gupshup_userid',
      'gupshup_password',
      'webhook_url',
      'emails',
    ],
  },
  23: {
    name: 'Salesforce Agent Chat',
    requiredFields: [
      'base_url',
      'org_id',
      'deployment_id',
      'button_id',
      'chat_request_fail',
      'chat_request_pending',
      'chat_ended',
    ],
  },
  30: {
    name: 'Infobip Chat Connector',
    requiredFields: [
      'infobip_base_url',
      'scenario_key',
      'auth_token',
      'bot_wa_number',
    ],
  },
  33: {
    name: 'ZendeskLiveChat',
    requiredFields: [
      'zd_client_id',
      'client_name',
      'subdomain',
      'client_secret',
      'agent_offline_message',
    ],
  },
  32: {
    name: 'Telegram',
    requiredFields: ['telegram_base_url', 'telegram_access_token'],
  },
  37: {
    name: 'Shopify Connector',
    requiredFields: [
      'domain_name',
      'api_key',
      'api_token',
      'admin_token',
      'storefront_token',
    ],
  },
  39: {
    name: 'Microsoft Teams',
    requiredFields: ['teams_client_id', 'teams_client_secret'],
  },
  40: {
    name: 'KMSIntegration',
    requiredFields: ['kms_type', 'bot_name', 'kms_settings'],
  },
  41: {
    name: 'Instagram',
    requiredFields: [], // it is being sent automatically and user wouldn't be entering any data so this is made empty
  },
  44: {
    name: 'Line',
    requiredFields: [
      'channel_id',
      'channel_access_token',
      'line_client_secret',
    ],
  },
  48: {
    name: 'Instagram Classic',
    requiredFields: [
      'ic_access_token',
      'ic_app_secret_key',
      'ic_secret_challenge_key',
      'ic_secret_key',
      'ic_page_id',
    ],
  },
  49: {
    name: 'Viva Connect',
    requiredFields: ['vc_user_name', 'vc_password', 'vc_api_key'],
  },
  53: {
    name: 'GorgiasWidget',
    requiredFields: [
      'gorgias_widget_username',
      'widget_api_base_url',
      'gorgias_default_team_id',
      'haptik_iva_gorgias_email',
      'haptik_iva_gorgias_id',
    ],
  },
  26: {
    name: 'Twilio',
    requiredFields: [
      'twilio_password',
      'sms_destination_application_id',
      'twilio_account_sid',
      'twilio_mobile_no',
    ],
  },
  56: {
    name: 'Fynd',
    requiredFields: [],
  },
  57: {
    name: 'Magento',
    requiredFields: [
      'haptik_username',
      'haptik_password',
      'magento_domain',
      'magento_buzzo_mapping',
      'magento_media_url',
      'magento_storeview',
    ],
  },
  58: {
    name: 'Clevertap',
    requiredFields: ['ct_webhook_url'],
  },
  59: {
    name: 'WooCommerce',
    requiredFields: ['wc_domain', 'wc_username', 'wc_password'],
  },
  60: {
    name: 'Radisys',
    requiredFields: ['radisys_base_url', 'api_key'],
  },
  63: {
    name: 'Microsoft Dynamic 365',
    requiredFields: [
      'microsoft_dynamic_client_id',
      'microsoft_dynamic_client_secret',
      'microsoft_dynamic_resource_url',
      'microsoft_dynamic_service_root_url',
    ],
  },
  72: {
    name: 'RCS',
    requiredFields: [
      'access_token',
      'assistant_id',
    ],
  },
};

// Error message if the text deployment fields on trim, results in an empty string.
export const TRIM_ERROR =
  'Leading and trailing spaces not allowed in platform deployments.';

export const WHATSAPP_PLATFORM_ID = 10;
